module.exports = __webpack_public_path__ + "c359494bced868523a20d4f0612b7513.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-03-04/whats-new.html
// module id = 1901
// module chunks = 0